import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Icon, Tags } from '@qure/containers'
import _ from 'lodash'
import { useStoreState } from 'pullstate'
import { useTranslation } from 'react-i18next'
import UIStore from 'states/globalStore'

import Dropdown from '../Dropdown'
import useLocalStorage from '../../libs/hooks/useLocalStorage'

// const getDefaultSite = userProfile => {
//   let defaultSite = _.first(_.get(userProfile, 'sites', []))
//   if (!_.isEmpty(defaultSite)) {
//     defaultSite = {
//       label: _.get(defaultSite, ['additional', 'label']),
//       id: defaultSite.name
//     }
//   }

//   return defaultSite
// }
function SiteSelector(props) {
  const { onSelectSiteCallback } = props

  const { userProfile, selectedSite } = useStoreState(UIStore, s => ({
    userProfile: s.userProfile,
    selectedSite: s.selectedSite
  }))
  const { t } = useTranslation()

  const activeItem = { label: 'All', id: 'all' }

  const [firstSite, setSiteInLocal] = useLocalStorage('site', activeItem)

  useEffect(() => {
    if (_.isEmpty(selectedSite)) {
      UIStore.update(s => {
        // eslint-disable-next-line no-param-reassign
        s.selectedSite = firstSite
      })
    }
  }, [firstSite])

  const onSelectSite = siteData => {
    // update the site in the store selectedSite
    UIStore.update(s => {
      // eslint-disable-next-line no-param-reassign
      s.selectedSite = siteData
    })
    setSiteInLocal(siteData)
    if (onSelectSiteCallback) {
      onSelectSiteCallback()
    }
  }

  let apiSitesData = _.get(userProfile, ['sites'], [])
  apiSitesData = apiSitesData.map(site => {
    return {
      label: _.get(site, ['additional', 'label']),
      id: site.name
    }
  })

  apiSitesData.unshift(activeItem)

  return (
    <div className="site-selector content px-3 ">
      <h3>
        <Icon iConClass="fa-map-marker-alt" />
        <span className="is-uppercase has-word-break-all">
          {_.get(selectedSite, ['label'], '')}
        </span>
      </h3>
      <Dropdown
        data={apiSitesData}
        activeItem={firstSite}
        searchPlaceholder={t('Search')}
        onSelect={onSelectSite}
        isSearchable
        DropdownTrigger={() => (
          <Tags color="primary" className="is-medium">
            <Icon iConClass="fa-pencil-alt" />
            <span>{t('Change site')}</span>
          </Tags>
        )}
      />
    </div>
  )
}

SiteSelector.defaultProps = {
  onSelectSiteCallback: null
}

SiteSelector.propTypes = {
  onSelectSiteCallback: PropTypes.func
}

export default SiteSelector
